<template>
    <q-card class="full-height relative-position shadow-transition cursor-pointer card-bottom-line reward" :class="class_hover" @click="allowed_to_redeem ? $router.push({ name: 'reward_details', params: { id: reward.id } }) : null" @mouseover="setClassHover('mouseover')" @mouseleave="setClassHover('mouseleave')">
        <img :src="reward.reward_image ? reward.reward_image : `placeholders/reward.png`">

        <q-card-section class="title-container">
            <div class="text-subtitle2 title">
                {{ reward.title }}
            </div>

            <div class="text-caption text-grey-6 text-weight-bold">
                {{ reward.suplyer_name }}
            </div>
        </q-card-section>

        <q-card-section class="absolute-bottom">
            <q-btn :label="`${parseInt(reward.price)} ${$t('point', {count: parseFloat(reward.price)})}`" :ripple="false" unelevated color="grey-4" class="full-width intel-light-blue text-lowercase text-weight-bold" />
        </q-card-section>

        <q-tooltip anchor="center middle" self="center middle" v-if="!allowed_to_redeem">
            {{ $t('you_must_complete_all_required_training_before_redeeming') }}
        </q-tooltip>
    </q-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Reward',

    props: ['reward', 'allowed_to_redeem'],

    data() {
        return {
            class_hover: ''
        }
    },

    computed: {
        ...mapGetters({
            reward_categories: 'site_lists/reward_categories'
        })
    },

    methods: {
        getCategory(id) {
            let obj = this.reward_categories.find((e) => e.id === id)
            if (obj) return obj.title
            return ''
        },

        setClassHover(state) {
			if (this.allowed_to_redeem) this.class_hover = 'disabled'
			else {
				if (state === 'mouseover') this.class_hover = 'shadow-5'
				else this.class_hover = ''
			}
		}
    },

	created() {
		if (this.allowed_to_redeem) this.class_hover = 'disabled'
	}
}
</script>

<style lang="scss" scoped>
.reward {
	min-height: 350px;
}
.title {
	line-height: 1.5rem;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.title-container {
	height: 200px;
}
</style>